import { Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IBlacklistGet } from "../../../../models/blacklist";
import { Chip } from "@mui/material";
import MainApiService from "../../../../services/mainApi.service";

const BLACKLIST_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/BlackList/";
const blacklistService = new MainApiService<IBlacklistGet>(BLACKLIST_ROUTE);

const translationPath = "chatBot.page.service.blacklist.";

export const BlacklistPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<IBlacklistGet>[] = [
    {
      field: "individual",
      headerName: t(translationPath + "name") || "Name",
      valueGetter: (params) =>
        params.row.individual ? params.row.individual.name : "",
      renderCell: (params) => params.value || "-",
    },
    {
      field: "phoneNumber",
      headerName: t(translationPath + "phone_number") || "Phone Number",
      renderCell: (params) => (params.value ? params.value : "-"),
    },
    {
      field: "created",
      headerName: t(translationPath + "creation_date") || "Creation Date",
      renderCell: (params) =>
        params.value
          ? new Date(
              params.value.slice(0, 10) + "T00:00:00"
            ).toLocaleDateString("pt-BR")
          : "-",
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 120,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleRowClick = (params: GridRowParams<IBlacklistGet>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<IBlacklistGet>
      showDefaultMacroFilters={false}
      service={blacklistService}
      columns={columns}
      title={t(translationPath + "blacklist_registrations") || "Blacklist"}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for blacklist registration"
      }
      addButtonLabel={
        t(translationPath + "add_button") || "Add blacklist registration"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};
